import { useStateManagementSlice } from '@gef-ui/context-defaults';
/**
 * Unlike `useStore` from `react-redux`, this hook will not fail when store is not available.
 *
 * @documented
 * @category Form
 * @import import useReduxStore from '@gef-ui/form-core/hooks/form/useReduxStore'
 * @returns {Object} [reduxStore]
 * @example
 *
 * 	const store = useReduxStore();
 *
 */ const useReduxStore = ()=>{
    return useStateManagementSlice('react-redux').useSafeStore();
};
export default useReduxStore;
